<div class="horizontalMenuContainer chatlayout">
  <div class="page">
    <div class="page-main">
      <app-header></app-header>

      <app-agent-sidebar appHoverEffectSidebar> </app-agent-sidebar>
      <div class="app-content main-content">
        <div class="main-container">
          <div class="width100">
            <router-outlet><app-loader></app-loader></router-outlet>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
